import React, { Component } from "react";
import dotenv from 'dotenv';
import Helper from '../../Devices/DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    update_state_item,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
} from "../../reducers/dev";

import { Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import SPr_01a_Devs from "./SPr_01a_Devs"
import SPr_01b_DevsMobile from "./SPr_01b_DevsMobile"
///run/user/1000/gvfs/sftp:host=xtal.asia,user=venus/home/venus/docker/4028-29-30_wifi_api_react/app/frontend/src/Devices/DevServices/Chart.jsx

dotenv.config();

class PageProjects extends Component {


/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
   this.props.update_state_item('selected_project_desks', {})
  }
  
  componentDidMount(){
    const rx_project_id = this.props.match.params.project_id
    //console.log(rx_project_id)
    this.props.t_get_project_desks_by_user_and_project_id(rx_project_id)
  }



  render() {
    // Check if the user is authenticated or exists
    if (!this.props.user) {
      // Redirect to an external URL
      //window.location.href = "https://google.com";
      window.location.href = process.env.REACT_APP_HOST+"/login";
      return null; // Return null to avoid rendering anything else
    }
    //Get Projects by user_role
    

    return (
    <div className="">

    <h4 className="text-secondary">Selected Project: <span className="text-primary" >{this.props.dev?.selected_project_desks?.projectName}</span></h4>
    
    {/* DevsExample(this.props.dev.selected_project_desks.desks) */}
    
    {/* Desktop case */}
    <div className="d-none d-md-block">
      <SPr_01a_Devs
        data = {this.props.dev.selected_project_desks.desks}
        onlineContent = {onlineContent}
      />
    </div>

    {/* Mobile case */}
    <div className="d-md-none" >
      <SPr_01b_DevsMobile
        data = {this.props.dev.selected_project_desks.desks}
        onlineContent = {onlineContent}
      />
    </div>



      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    update_state_item,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageProjects);


const DevsExample1 = (data) => {
  //console.log(data)
  if (!data) return null
  return (
    <div className="container mt-1">
    <table className="table table-striped">
        <thead>
            <tr>
                <th>ID</th>

                <th>Desk Name</th>
                <th>qty</th>
                <th>Online</th>
                <th>Mobile</th>

            </tr>
        </thead>
        <tbody>
          {
            data.map((v,i) => {
              return (
                <tr key={`desk_${i}`}>
                <td><Link to={`/selected_desk/${v.id}`}>{v.id}</Link></td>
                <td><Link to={`/selected_desk/${v.id}`}><span className="text-secondary">{v.desk_name}</span></Link></td>
                <td>{v.dev_qty}</td>
                <td>
                {onlineContent(v.dev_online)}
                </td>
                <td><Link to={`/selected_desk_mobile/${v.id}`}>test</Link></td>
    
              </tr>
              )
            })
          }

        </tbody>
    </table>
</div>
  )
}

const onlineContent = (onlineObj) => {
  const out = []
  
/*   out.push(<span className="green-bullet me-2">3</span>)
  return <><span className="text-success">3</span>, <span className="text-danger">3</span>, <span className="text-warning">3</span></> 
 */
  if (onlineObj.online > 0) out.push(<span className="text-success">{onlineObj.online}</span>)
  if (onlineObj.offline > 0) out.push(<span className="text-danger">{onlineObj.offline}</span>)
  if (onlineObj.na > 0) out.push(<span className="text-warning">{onlineObj.na}</span>)
/*   out.push(<span className="text-success">3</span>)
  out.push(<span className="text-danger">3</span>)
  out.push(<span className="text-warning">3</span>) */
  return <div className="d-inline-flex"> 
              {out.map((v, i) => {
                if (i === 0) return <div key={i}>{v}</div>
                return <div key={i}>, {v}</div>
              })}
  </div> 

}